import React from 'react'

export default function Footer() {
	return (
		<>
			<footer className="footer container-fluid pl-30 pr-30">
				<div className="row">
					<div className="col-sm-12">
						<p>2024 &copy; Powered by Cloudnet Pvt. Ltd.</p>
					</div>
				</div>
			</footer>
		</>
	)
}
